
import { useLog } from '@/common/log';
import { useBroadcast, useBroadCastStream } from '@/common/utils';
import { plTooltip as PlTooltip } from '@ks/platform-ui';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { ReportOption, menuSymbol } from './setting';
import { debounce } from 'lodash';
export default defineComponent({
    props: {
        isLogin: {
            type: Boolean,
        },
        reportOptions: {
            type: Object as PropType<ReportOption>,
            default: () => ({
                reportType: 1,
                page: '',
                targetId: '',
                reportedUserId: '',
                extraPhotoId: '',
            }),
        },
    },
    components: {
        PlTooltip,
    },
    setup(props) {
        const broadcast = useBroadcast();
        const reportName = computed(() => `举报${menuSymbol[props.reportOptions.reportType as keyof typeof menuSymbol].name}`);
        const isAbsoluteMode = ref(true);
        const log = useLog();
        const handleReport = debounce(async () => {
            log({
                type: 'CLICK',
                event_name: 'REPORT_BUTTON',
                event_value: {
                    btn_type: menuSymbol[props.reportOptions.reportType as keyof typeof menuSymbol].logName,
                },
            });
            if (!props.isLogin) {
                return broadcast('login', {});
            }
            broadcast('change-report-panel', { ...props.reportOptions });
        }, 500);
        useBroadCastStream('change-tooltip-mode', (val: boolean) => {
            isAbsoluteMode.value = val;
        });
        return {
            handleReport,
            menuSymbol,
            reportName,
            isAbsoluteMode,
        };
    },
});
